import React, { useEffect } from 'react'
import { ArrowLeft, CheckSvg, UncheckSvg } from '../../../../../components/IconSvg'
import { ContactCategory, IContact, PhoneBook } from '../../../../../service/interfaces/contacts'
import Possibilities from './possibilities'
import EditContactModal from './editContact/editContactModal'
import CallDirect from '../../../callDirect'
import { useDispatch } from 'react-redux'

const ContactTableColumns = ({ setColumns }: { setColumns: Function, setSelectedList: Function }) => {
    const dispatch = useDispatch()

    const selectionComponent = ({ item, selectedList, setInnerSelectedList }:
        { item: IContact, selectedList: IContact[], setInnerSelectedList: Function }) => {
        const handleClick = () => {

            if (selectedList.some((i: IContact) => i === item)) {
                setInnerSelectedList({ selectionList: [...selectedList.filter((i: IContact) => i !== item)] })
            } else {
                let tempList = [...selectedList]
                tempList.push(item)
                setInnerSelectedList({ selectionList: [...tempList] })
            }
        }
        return (<span onClick={handleClick}>
            {selectedList?.some((i: IContact) => i === item) ? <CheckSvg fill='#1E72C9' /> : <UncheckSvg />}
        </span>)
    }

    const PhonebookComponent = ({ item, phonebookList }: { item: IContact, phonebookList: PhoneBook[] }) => {

        return (<span>{phonebookList?.find((_item: PhoneBook) => _item.id === item.phoneBookId)?.name}</span>)
    }
    const categoryComponent = ({ contactCategories, item }: { contactCategories: ContactCategory[], item: IContact }) => {

        return (<>
            {item.contactCategoryIds.map((_item: string, idx: number) => <div key={idx}>{contactCategories?.find((i: ContactCategory) => i.id === _item)?.name}</div>)}
        </>)
    }
    const extensionComponent = ({ item, updateContact, updateContactPending, handleBlock }:
        { item: IContact, updateContact: Function, updateContactPending: boolean, handleBlock: Function }) => {
        return (<Possibilities {...{ item, updateContact, updateContactPending, handleBlock }} />)

    }

    const descriptionComponent = ({ item, updateContact, updateContactPending, handleSelectItemToEdit }:
        { item: IContact, updateContact: Function, updateContactPending: boolean, handleSelectItemToEdit: Function }) => {
        return (<div className='d-flex justify-content-between' >
            <div></div>

            <span className='edit-spn' onClick={() => { handleSelectItemToEdit(item) }}//setContactStates({ selectedItemToEdit: item, displayUpdateContact: true }); }}
            >ویرایش

                <ArrowLeft fill={'#000'} />

            </span>

        </div>)
    }

    const numberComponent = ({ item }: { item: IContact }) => {
        return (
            <>
                <div onClick={() => dispatch({ type: 'callDirect', show: true, number: item.defaultNumber })}>
                    {item.defaultNumber.startsWith('98') ? item.defaultNumber.replace('98', '0') : item.defaultNumber}
                </div>
                {item.number2 && <div>{item.number2.startsWith('98') ? item.number2.replace('98', '0') : item.number2}</div>}
                {item.number3 && <div>{item.number3.startsWith('98') ? item.number3.replace('98', '0') : item.number3}</div>}
                {item.number4 && <div>{item.number4.startsWith('98') ? item.number4.replace('98', '0') : item.number4}</div>}
            </>
        )
    }
    useEffect(() => {
        setColumns([
            { title: 'انتخاب', property: '', filterProperty: 'null', hasSort: false, hasFilter: false, display: true, component: selectionComponent },
            { title: 'نام', property: 'name', filterProperty: 'null', hasSort: true, hasFilter: false, display: true },
            { title: 'نام خانوادگی', property: 'familyName', filterProperty: 'null', hasSort: false, hasFilter: false, display: true },
            { title: 'شماره', property: 'defaultNumber', filterProperty: 'null', hasSort: false, hasFilter: false, display: true, component: numberComponent },
            { title: 'دفترچه تلفن', property: 'test', filterProperty: 'null', hasSort: true, hasFilter: false, display: true, component: PhonebookComponent },
            { title: 'دسته بندی', property: '', filterProperty: 'null', hasSort: false, hasFilter: false, display: true, component: categoryComponent },
            { title: 'افزونه ها', property: '', filterProperty: 'null', hasSort: false, hasFilter: false, display: true, component: extensionComponent },
            { title: 'توضیحات', property: 'description', filterProperty: 'null', hasSort: false, hasFilter: false, display: true, component: descriptionComponent },
        ])
    }, [])

    return null
}

export default ContactTableColumns